export const DownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18.6 12.6V16.6C18.6 17.1304 18.3893 17.6391 18.0142 18.0142C17.6391 18.3893 17.1304 18.6 16.6 18.6H2.59998C2.06954 18.6 1.56083 18.3893 1.18576 18.0142C0.810689 17.6391 0.599976 17.1304 0.599976 16.6V12.6M4.59998 7.59998L9.59998 12.6M9.59998 12.6L14.6 7.59998M9.59998 12.6V0.599976"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
